import { render, staticRenderFns } from "./MessageDate.vue?vue&type=template&id=9d62a400&scoped=true&"
import script from "./MessageDate.vue?vue&type=script&lang=js&"
export * from "./MessageDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d62a400",
  null
  
)

export default component.exports